import React from 'react';

import {
  CalendarAndClockIcon,
  Card,
  Container,
  Description,
  Name,
  TitleIconContainer,
  TitleSection
} from './AppointmentTypeCard.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { useBreakpoints } from 'utilities/useBreakpoints';

interface Props {
  onClick: () => void;
}

export const PartnerClinicCard = ({ onClick }: Props) => {
  const { isDesktop } = useBreakpoints();

  return (
    <Container>
      <Card>
        <TitleSection>
          <TitleIconContainer>
            <CalendarAndClockIcon />
          </TitleIconContainer>
          <Name>Don't live near a Kindbody Clinic & have employer benefits?</Name>
        </TitleSection>
        <Description>Search our network to get started!</Description>
        <Button
          label="Find a Partner Clinic"
          size={isDesktop ? 'md' : 'lg'}
          category="primary"
          onClick={onClick}
          fullWidth
        />
      </Card>
    </Container>
  );
};
